export const GET_LOOSENESS_RESULT = "GET_LOOSENESS_RESULT";
export const GET_LOOSENESS_RESULT_SUCCESS = "GET_LOOSENESS_RESULT_SUCCESS";
export const GET_LOOSENESS_RESULT_ERROR = "GET_LOOSENESS_RESULT_ERROR";
export const RESET_LOOSENESS_RESULT = "RESET_LOOSENESS_RESULT";
